import { sendAnalytics } from 'shared/utils/analytics';

interface ISendInfrastructureAnalytics {
  action: string;
  infrastructureType: string;
  label?: string;
}

export const sendInfrastructureAnalytics = ({ action, infrastructureType, label }: ISendInfrastructureAnalytics) =>
  sendAnalytics({ category: 'Infrastructure', action, label, page: { extra: { infrastructureType } } });
